<template>
    <div>
        <el-popover
            ref="popover4"
            v-model="visible"
            placement="left"
            :visibleArrow="false"
            popperClass="editPop"
            trigger="click">
            <el-card>
                <div slot="header">修改商品信息</div>
                <pro-option
                    :type="2"
                    :list="list"
                    :goods_id="goods_id"
                    :getCartProducts="getCartProducts"
                    :visible.sync="visible"
                    :rec_id="rec_id"
                    :qtyRaw="qtyRaw"
                ></pro-option>
            </el-card>
        </el-popover>
        <span v-popover:popover4><slot></slot></span>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ProOptions from '../../components/Common/ProOptions.vue';

    Vue.component('pro-option', ProOptions);
    export default {
        props: ['list', 'goods_id', 'getCartProducts', 'rec_id', 'qtyRaw'],
        data () {
            return {
                visible: false,
            };
        }
    };
</script>
<style lang="less">
    .editPop {
        padding: 0;
        .el-card {
            width: 480px;
            /deep/ .el-card__header {
                padding: 5px 16px;
                background: #f0f1f2;
                font-size: 12px;
                color: #9ca2ad;
            }
            /deep/ .el-card__body {
                color: #636975;
                padding: 16px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SupplyCh/Popover.vue